var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 18.375C11.5342 18.375 12.5582 18.1713 13.5136 17.7756C14.4691 17.3798 15.3372 16.7997 16.0685 16.0685C16.7997 15.3372 17.3798 14.4691 17.7756 13.5136C18.1713 12.5582 18.375 11.5342 18.375 10.5C18.375 9.46584 18.1713 8.44181 17.7756 7.48637C17.3798 6.53093 16.7997 5.6628 16.0685 4.93153C15.3372 4.20027 14.4691 3.6202 13.5136 3.22445C12.5582 2.82869 11.5342 2.625 10.5 2.625C8.41142 2.625 6.40838 3.45468 4.93153 4.93153C3.45469 6.40838 2.625 8.41142 2.625 10.5C2.625 12.5886 3.45469 14.5916 4.93153 16.0685C6.40838 17.5453 8.41142 18.375 10.5 18.375ZM10.297 13.685L14.672 8.435L13.328 7.315L9.5655 11.8291L7.61862 9.88138L6.38138 11.1186L9.00638 13.7436L9.68363 14.4209L10.297 13.685Z",
    fill: "#2C963D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmark);
export default __webpack_public_path__ + "static/media/tickmark.5cab725477b816e6cf216b70d6df0d34.svg";
export { ForwardRef as ReactComponent };